<template>
    <div>
        <loading-component v-model="loading"></loading-component>
        <v-container class="grey lighten-5">
            <v-row no-gutters>
                <v-col cols="4" sm="6" md="8" lg="3"                        v-if="info.contract_template">
                    <v-card v-if="info && info.contract_template" class="pa-2" outlined tile>
                        <p class="m-2" style="font-size: 20px"><span
                                class="font-weight-medium">Contract Template:</span> {{info.contract_template.name}}</p>
                    </v-card>
                </v-col>
                <v-col cols="4" sm="6" md="8" lg="3" v-if="info && info.level">
                    <v-card class="pa-2" outlined tile>
                        <p class="m-2" style="font-size: 20px"><span class="font-weight-medium">Level:</span>
                            {{info.level.name}}</p>
                    </v-card>
                </v-col>
                <v-col
                        cols="4"
                        md="4"
                        lg="3"
                >
                    <v-card
                            class="pa-2"
                            outlined
                            tile
                    >
                        <v-btn color="primary" dark @click.native.stop="change_level_dialog = true">Change Level</v-btn>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="change_level_dialog" max-width="800">
            <v-card>
                <v-container>
                    <v-form ref="change_level_form" v-model="valid" :lazy-validation="lazy">
                        <v-card-title>
                            <span class="headline">Change Level</span>
                        </v-card-title>
                        <choose-date label="Level join date" :rules="requiredRules"
                                     v-model="model.level_join_date"></choose-date>
                        <v-select
                                label="Choose level"
                                v-model="selected_level"
                                :items="levels"
                                :rules="requiredRules"
                                item-text="name"
                                return-object
                        ></v-select>

                        <v-select
                                v-if="selected_level"
                                v-model="selected_bonus_packages"
                                label="Choose bonus packages"
                                multiple
                                :items="selected_level.bonus_packages"
                                item-value="id"
                                item-text="name"
                        ></v-select>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat @click="change_level_dialog = false">Close</v-btn>
                            <v-btn color="primary" @click="changeLevel">Save</v-btn>
                        </v-card-actions>

                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
        <DataTable
                ref="datatable"
                :url="url"
                disableSearch
                descending
                :titles="titles"
                :fieldsHiddenMain="['updated_at', 'contract_document']"
                title="Contracts"
                :enableEdit="false"
                force-reload
                :enableDelete="false"
                :actionsExtraMain="actionsExtraMain"
                :formatter="formatter"
                :rowCallBack="rowCallBack"
        ></DataTable>

        <v-dialog v-model="dialog" width="60%">
            <v-card>
                <v-card-title>
                    <span class="headline">New Contract</span>
                </v-card-title>
                <contract-info :required_file="false" ref="contract_info" @next_step="done"></contract-info>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="dialog = false">Close</v-btn>
                    <v-btn color="primary" @click="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ContractInfo from "@/components/confirmation_captain_components/ContractInfo";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseLevel from "@/components/wasilni/input/ChooseLevel";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "Contracts",
        components: {LoadingComponent, ChooseDate, ContractInfo, DataTable, ChooseLevel},
        props: ['captain_id'],
        data() {
            return {
                rowCallBack: (item) => {
                    if (!item.deleted_at) return ["active-contract"];
                    return [];
                },
                dialog: false,
                change_level_dialog: false,
                loading: false,
                valid: true,
                lazy: false,
                requiredRules: [(v) => !!v || "الحقل مطلوب"],
                url: `captain/${this.captain_id}/contracts`,
                info: {
                    contract_template: null,
                    level: null
                },
                levels: null,
                selected_level: null,
                selected_bonus_packages: [],
                model: {
                    captain_id: this.captain_id,
                    new_level_id: null,
                    new_bonus_packages: [],
                    level_join_date: null
                }
            }
        },
        methods: {
            submit() {
                this.$refs['contract_info'].submit();
            },
            done() {
                this.dialog = false;
                this.$refs['datatable'].getData();
            },
            changeLevel() {
                if (!this.$refs.change_level_form.validate()) {
                    return;
                }
                this.model.new_bonus_packages = [];
                this.model.new_level_id = this.selected_level.id;
                this.model.new_bonus_packages = this.selected_bonus_packages;
                this.model.captain_id = this.captain_id;
                this.loading = true;

                this.axios
                    .post(
                        `captain/${this.captain_id}/level_change`,
                        this.model
                    )
                    .then((res) => {
                        this.info.level = res.data.data[0];
                        this.$set(this.info.level, 'name', res.data.data[0].name);
                        this.change_level_dialog = false;
                        window.getApp.$emit("SHOW_TOAST", "Done", "green");
                    })
                    .catch((err) => {
                        let message;
                        try {
                            message = err.response.data.message;
                        } catch (e) {
                            message = "Error happened";
                        }
                        window.getApp.$emit("SHOW_TOAST", message, "red");
                    })
                    .finally(() => {
                        this.loading = false
                    });
            }
        },
        mounted() {
            this.axios
                .get(
                    `captain/${this.captain_id}/contract_info`
                )
                .then((res) => {
                    this.info = res.data.data;
                    this.axios.get(`contract_template/${this.info.contract_template.id}/level`)
                        .then((res) => {
                            this.levels = res.data.data;
                        }).catch(err => console.log(err.message));
                }).catch(err => console.log(err.message))
                .finally(() => this.loading = false);
        },
        computed: {
            titles() {
                return {
                    "id": "ID",
                    'percentage': 'Percentage',
                    'per_hour': 'Per Hour',
                    'per_km': 'Per KM',
                    "created_at": "Contracted At",
                    "deleted_at": 'Status'
                }
            },
            formatter() {
                return {
                    deleted_at: (value) => {
                        if (value == null) return "ACTIVE";
                        return 'Ended at ' + this.moment(value).format('DD MMM YYYY');
                    },
                    created_at: (value) => this.moment(value).format('DD MMM YYYY')
                }
            },
            actionsExtraMain() {
                return {
                    add: {
                        action: () => {
                            this.$refs['contract_info'].reset();
                            this.$refs['contract_info'].update(this.captain_id, true);
                            this.dialog = true;
                        }
                    }
                }
            }
        }
    }
</script>

<style>
    .active-contract {
        background: lightgreen;
    }
</style>
